<template>
  <svg v-if="isFill" xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" :opacity="opacity" :style="{ color: color }" viewBox="0 0 36 36" fill="none">
    <path :d="notePath" fill="#FE2C55" transform="translate(1.6 1.6)" />
    <path :d="notePath" fill="#010101" />
  </svg>
  <svg v-else xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" :opacity="opacity" :style="{ color: color }" viewBox="0 0 36 36" fill="none">
    <path :d="notePath" :stroke="color" stroke-width="2" stroke-linejoin="round" />
  </svg>
</template>

<script>
// Original simplified music-note glyph (not the official trademark) — replace with the official logo after brand-guideline review.
const CONST_NOTE_PATH = 'M17 5h4c0 4 3 7.2 8 7.7v4.2c-3-.3-6-1.4-8-3.3v11.4a5.5 5.5 0 1 1-4-5.29z';

export default {
  name: 'TikTokIcon',
  props: {
    size: {
      type: [String, Number],
      default: 24,
    },
    color: {
      type: String,
      default: 'currentColor',
    },
    opacity: {
      type: [String, Number],
      default: 1,
    },
    isFill: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    notePath() {
      return CONST_NOTE_PATH;
    },
  },
};
</script>
